<a href="javascript:void(0)" (click)="openModalUserDetails(userName)">
    {{ displayName || userName }}
</a>
